export default "__VITE_ASSET__FclYRhzr__"